



















import CategoryServices, { CategoryDto } from '@/services/category';
import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator';
@Component
export default class KNewFolder extends Vue {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  @Prop() categoryType!: number;
  @Prop() folderId!: number;
  @Prop() parentEntityId!: any;

  categorySrv = new CategoryServices();

  title = '新建目录';
  @Watch('visible')
  async onVisibleChange() {
    if (this.folderId > 0) {
      this.formData = await this.categorySrv.getInfo(this.folderId);
      this.title = '编辑目录';
    } else {
      this.title = '新建目录';
      this.formData = {};
    }
  }

  loading: boolean = false;
  formData: CategoryDto = {};
  async addFolder() {
    if (!this.formData.categoryName) {
      this.$message.error('目录名称不能为空');
      return false;
    }
    if (this.parentEntityId) {
      this.formData.parentEntityId = this.parentEntityId;
    }
    this.loading = true;
    if (this.folderId > 0) {
      let res: CategoryDto | boolean = await this.categorySrv.update(this.formData);
      this.loading = false;
      if (!res) return false;
      this.syncVisible = false;
      this.$emit('edit', this.formData);
    } else {
      let res: CategoryDto | boolean = await this.categorySrv.add({ ...this.formData, categoryType: this.categoryType, categoryLevel: 1, categorySort: 0, icon: 'fa-folder-open-o' });
      this.loading = false;
      if (!res) return false;
      this.syncVisible = false;
      this.$emit('add', res);
    }
  }
}
